import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';

const setThrow = (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'string',
    required: true,
    pattern: /^\d+$/,
  };
  const result = validate(arg, scheme);

  if (result.isValid) throw new Error(arg);
};
export default setThrow;
